<progress-stepper-smart-fix-hub
  *ngIf="formattedSteps.length > 0"
  [steps]="formattedSteps"
  [startPage]="startPagePresent"
  [title]="articleTitle"
>
</progress-stepper-smart-fix-hub>

<!--temp solution for now-->
<ng-container *ngIf="isVideoPath()">
  <div [content]="main" editable-area></div>

  <div class="feedback-survey-wrapper">
    <feedback-smart-fix-hub class="feedback-survey" />
  </div>

  <redirect-to-mmr
    *ngIf="environment.hasMyAccountIntegration"
  ></redirect-to-mmr>
</ng-container>
